import doc                 from '@widesk-core/decorators/doc';
import WebsiteServiceModel from '@/models/WebsiteServiceModel';

@doc.path('/event_display_modes/{?id}')
abstract class AbstractEventDisplayModeModel extends WebsiteServiceModel {
	declare protected _tsFilters: {
		partial: string;
	};

	@doc.string declare name: string;
	@doc.number declare value: number;
	@doc.string declare label: string;
}

export default AbstractEventDisplayModeModel;
